import { render } from "./HelpCoursesDialog.vue?vue&type=template&id=af51dbf8"
import script from "./HelpCoursesDialog.vue?vue&type=script&lang=js"
export * from "./HelpCoursesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__